import type { PropsWithChildren } from "react";

import { StyledChevronIcon, StyledHeader } from "./styles";
import type { CollapsibleTriggerProps } from "./types";

const CollapsibleTrigger = ({ isExpanded, children, onClick }: PropsWithChildren<CollapsibleTriggerProps>) => {
    return (
        <StyledHeader
            data-automation="collapsible-trigger"
            onClick={onClick}
        >
            <StyledChevronIcon
                iconName="chev-down"
                isExpanded={isExpanded}
                size="xs"
            />

            {children}
        </StyledHeader>
    );
};

export default CollapsibleTrigger;
